<template>
  <svg
    width="441"
    height="455"
    viewBox="0 0 441 455"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_8016_12760)">
      <ellipse
        cx="39.9962"
        cy="53.7304"
        rx="39.9962"
        ry="53.7304"
        transform="matrix(-0.866025 -0.5 -0.5 0.866025 282.006 200.996)"
        fill="#A370F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_8016_12760"
        x="0.479965"
        y="0.683578"
        width="440.046"
        height="453.692"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="88.093"
          result="effect1_foregroundBlur_8016_12760"
        />
      </filter>
    </defs>
  </svg>
</template>
